import React from 'react';
import StockForm from './stock/StockForm';
import { connect } from 'react-redux';
import { startSetStock, resetStock } from '../actions/CurrentStock'
import Stock from '../model/Stock';

interface IProps {
    startSetStock?: (ticker:string) => void;
    resetStock?: () => void;
    stock?:Stock;
    match?: { params: { id: string, tab:string }};
}

export class EditStockPage extends React.Component<IProps> {

    componentDidMount() {
        this.props.startSetStock!(this.props.match!.params.id);
    }

    componentWillUnmount(){
        this.props.resetStock!();
    }


    render() {

        return (
            <div className="padding">
                {this.props.stock && <StockForm
                stock={this.props.stock}
                tab={this.props.match!.params.tab}
                />}
            </div>
        )
    }
}

const mapStateToProps = (state:any) => {

    let obj = {
        stock: state.currentStock
    }
    return obj;
}

const mapDispatchToProps = (dispatch:any) => ({
    startSetStock : (ticker:string) => dispatch(startSetStock(ticker)),
    resetStock : () => dispatch(resetStock()),
})

const areStatesEqual = (next: any, prev: any) => {    
    let result = prev.currentStock === next.currentStock;           
    return result;
  }
export default connect(mapStateToProps, mapDispatchToProps, null, { areStatesEqual})(EditStockPage);